
		<div>
			<ng-template component-host></ng-template>
		</div>
	